import { IconButton } from "@mui/material";
import { type ReactElement } from "react";

import { IconArrowNarrowLeft } from "@dfp/react-icons";

type AppDialogBackButtonProps = {
  onClick: () => void;
};

export function AppDialogBackButton({
  onClick,
}: AppDialogBackButtonProps): ReactElement {
  return (
    <IconButton
      onClick={onClick}
      variant="contained"
      color="secondary"
      size="small"
    >
      <IconArrowNarrowLeft />
    </IconButton>
  );
}
